import { Build, StepDependencyContext } from "~/components/build/Show/lib/types";
import { isTerminalBuildState } from "~/constants/BuildStates";

interface Props {
  missingDependencies: StepDependencyContext["missing_dependencies"];
  build: Build;
}

export const MissingStepDependencies = (props: Props) => {
  if (!props.missingDependencies?.length) {
    return null;
  }

  return (
    <div>
      <p className="mb-3 mt-0">
        {isTerminalBuildState(props.build.state) ? (
          <span className="bg-red-100">The following dependencies were not found:</span>
        ) : (
          <span className="bg-orange-100">
            The following dependencies are either invalid or have yet to be resolved:
          </span>
        )}
      </p>

      <ul className="depth mb-3 max-w-lg divide-y rounded">
        {props.missingDependencies.map((dep) => (
          <li key={dep} className="monospace m-0 border-gray-300 p-2.5 text-xs">
            {dep}
          </li>
        ))}
      </ul>
      <p className="m-0">
        Check the pipeline is configured correctly, or see the{" "}
        <a href="/docs/pipelines/dependencies" className="text-inherit underline">
          documentation
        </a>
        .
      </p>
    </div>
  );
};
